import { Grid } from '@ltvco/refresh-lib';
import { StyledLink } from './components';

const SELL_YOUR_CAR_LINK = 'https://www.bumper.com/marketplace/sell-your-car';
const AUTO_INSURANCE_LINK = 'https://insurance.bumper.com/';
const MARKET_VALUE_LINK = 'https://www.bumper.com/tools/market-value/';

export function ToolsLinks() {
  return (
    <>
      <Grid item xs={12} sm={3}>
        <StyledLink to={SELL_YOUR_CAR_LINK} target="_blank">
          Sell Your Car
        </StyledLink>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLink to={AUTO_INSURANCE_LINK} target="_blank">
          Auto Insurance
        </StyledLink>
      </Grid>
      <Grid item xs={12} sm={3}>
        <StyledLink to={MARKET_VALUE_LINK} target="_blank">
          Market Value
        </StyledLink>
      </Grid>
    </>
  );
}
